import { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { Button, Skeleton } from "@finora/ui";
import { api } from "../../lib/api";

const BILLING_TYPE_OPTIONS = ["FREE", "PER_TRANSACTION", "MONTHLY", "PER_DOCUMENT", "PER_API_CALL", "PER_UNIT"];

export function ModuleGroupsPage() {
  const [newGroupName, setNewGroupName] = useState("");

  const { data: groups, isLoading } = useQuery({
    queryKey: ["module-groups"],
    queryFn: () => api.listModuleGroups(),
  });
  const { data: modules } = useQuery({ queryKey: ["admin-modules"], queryFn: () => api.listAdminModules() });

  const createGroup = useMutation({
    mutationFn: () => api.createModuleGroup(newGroupName),
    onSuccess: () => window.location.reload(),
  });

  const setPrice = useMutation({
    mutationFn: (payload: { groupId: string; moduleId: string; billingType: string; price: string }) =>
      api.setModuleGroupPrice(payload.groupId, payload.moduleId, payload.billingType, payload.price),
    onSuccess: () => window.location.reload(),
  });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-semibold text-slate-900">Billing grupe (cenovnici)</h1>
      </div>

      <div className="flex items-end gap-2 rounded-xl border border-border bg-surface p-4 shadow-subtle">
        <div className="flex-1">
          <label className="mb-1 block text-xs font-medium text-slate-500">Naziv nove grupe</label>
          <input
            value={newGroupName}
            onChange={(e) => setNewGroupName(e.target.value)}
            placeholder="npr. Business"
            className="h-9 w-full rounded-lg border border-border px-2 text-sm focus:border-brand focus:outline-none"
          />
        </div>
        <Button disabled={!newGroupName || createGroup.isPending} onClick={() => createGroup.mutate()}>
          <Plus className="h-4 w-4" aria-hidden /> Nova grupa
        </Button>
      </div>

      {isLoading ? (
        <Skeleton className="h-40 w-full" />
      ) : (
        groups?.map((group) => (
          <div key={group.id} className="rounded-xl border border-border bg-surface shadow-subtle">
            <div className="flex items-center justify-between border-b border-border px-4 py-3">
              <h2 className="text-sm font-semibold text-slate-800">{group.name}</h2>
              <span className="text-xs text-slate-400">{group.companyCount} firmi</span>
            </div>
            <table>
              <thead>
                <tr>
                  <th>Modul</th>
                  <th>Tip naplate</th>
                  <th>Cena</th>
                </tr>
              </thead>
              <tbody>
                {modules?.map((m) => {
                  const existing = group.prices.find((p) => p.moduleId === m.id);
                  return (
                    <tr key={m.id}>
                      <td className="font-medium text-slate-800">{m.name}</td>
                      <td>
                        <select
                          key={`${m.id}-${existing?.billingType ?? m.defaultBillingType}`}
                          defaultValue={existing?.billingType ?? m.defaultBillingType}
                          onChange={(e) =>
                            setPrice.mutate({
                              groupId: group.id,
                              moduleId: m.id,
                              billingType: e.target.value,
                              price: existing?.price ?? m.defaultPrice,
                            })
                          }
                          className="h-8 rounded-lg border border-border px-2 text-xs focus:border-brand focus:outline-none"
                        >
                          {BILLING_TYPE_OPTIONS.map((b) => (
                            <option key={b} value={b}>
                              {b}
                            </option>
                          ))}
                        </select>
                      </td>
                      <td>
                        <input
                          key={`${m.id}-${existing?.price ?? m.defaultPrice}`}
                          defaultValue={existing?.price ?? m.defaultPrice}
                          onBlur={(e) =>
                            setPrice.mutate({
                              groupId: group.id,
                              moduleId: m.id,
                              billingType: existing?.billingType ?? m.defaultBillingType,
                              price: e.target.value,
                            })
                          }
                          className="h-8 w-24 rounded-lg border border-border px-2 text-xs focus:border-brand focus:outline-none"
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
}
